var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.isFormValid,
        callback: function($$v) {
          _vm.isFormValid = $$v
        },
        expression: "isFormValid"
      }
    },
    [
      (_vm.currentAuthorizedPeople > 1 || _vm.currentAdditionalPeople > 1) &&
      _vm.isFormValid
        ? _c(
            "div",
            [
              _c("Form-Navigation-Buttons", {
                on: {
                  previousStep: _vm.previousStep,
                  validateStep: _vm.validateStep,
                  reset: function($event) {
                    return _vm.$router.push({ name: "tickets" })
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-card",
        { staticClass: "mb-12 pt-2 float-remover", attrs: { color: "white" } },
        [
          _c("Item-List", {
            ref: "list1",
            attrs: {
              "add-button": "Agregar persona - Empleado de la empresa",
              minItems: 1,
              maxItems: _vm.maxAuthorizedPeople,
              icon: "mdi-plus",
              "initial-ammount": 1
            },
            on: {
              itemsLength: _vm.calculateMaxAdditionalPeople,
              itemDeleted: _vm.authorizedPersonDeleted
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c("Authorized-Person", {
                      attrs: {
                        isFormComplete: props.isFormComplete,
                        oldItem: props.oldItem,
                        selectedValues: props.selectedValues
                      },
                      on: {
                        receiveAuthorizedPerson: _vm.receiveAuthorizedPerson,
                        authorizedPersonSelected: _vm.authorizedPersonSelected
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c(
            "v-row",
            { staticClass: "mr-2" },
            [
              _c("v-col", [
                _c("label", { staticClass: "font-weight-light" }, [
                  _vm._v(
                    "Para agregar a personas que no pertenecen a tu empresa, sino a un proveedor de servicio, haz clic en el siguiente botón:"
                  )
                ])
              ])
            ],
            1
          ),
          _c("Item-List", {
            ref: "list2",
            attrs: {
              "add-button": "Agregar una persona",
              minItems: 0,
              maxItems: _vm.maxAdditionalPeople,
              icon: "mdi-plus",
              "initial-ammount": 0
            },
            on: { itemsLength: _vm.calculateMaxAuthorizedPeople },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c("Additional-Person", {
                      attrs: {
                        isFormComplete: props.isFormComplete,
                        oldItem: props.oldItem
                      },
                      on: {
                        receiveAdditionalPerson: _vm.receiveAdditionalPerson
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("Form-Navigation-Buttons", {
        on: {
          previousStep: _vm.previousStep,
          validateStep: _vm.validateStep,
          reset: function($event) {
            return _vm.$router.push({ name: "tickets" })
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }